import React from 'react';
import {Container} from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { postDataLogin } from '../ApiServices/ApiService';
import { FaSignOutAlt,FaHome } from 'react-icons/fa';
import { RiDashboardFill } from "react-icons/ri";
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Logo from './../assets/icons/logo2.jpeg';
// import { TfiAlignRight } from "react-icons/tfi";
//import { useHistory } from 'react-router-dom';


const NavHeader = () => {
  const navigate = useNavigate();
  const aminInfo = JSON.parse(localStorage.getItem('ai-admin'));
 

  const handleLogout = () =>{
    console.log('logout');
    localStorage.clear();
    navigate('/login')
  }
  const Dashboard =()=>{
    navigate("/job-post");
  }
  const InterviewTabLink =()=>{
    navigate("/interviews-tab");
  }
  const manageClient = ()=>{
    navigate("/clients-page");
  }
  const addJobs = ()=>{
    navigate("/add-job-post");
  }

  const handleHome =()=>{
    // navigate("/candidate");
  }
  const gotoDashboard =()=>{
    navigate("/job-post");
  }

  return (
    <>
 <Navbar expand="lg" className="nav-background pad-4" style={{padding:4}}>
      <Container fluid>
      {/* <TfiAlignRight /> */}
      <img src={Logo} className='nav-logos'/>
        <Navbar.Brand className='nav-heading' onClick={gotoDashboard} style={{cursor:'pointer'}}>EngageTalent.AI</Navbar.Brand>
        <Navbar.Toggle aria-controls="navbarScroll" className='navbar-icon-toggle'/>
        <Navbar.Collapse id="navbarScroll">
          <Nav className="mx-auto" style={{ maxHeight: '100px' }} >
            {/* Add the "Dashboard" heading here */}
            {/* <Nav.Link className="margin-right">Candidate Details</Nav.Link> */}
            <Nav.Link className="margin-right navheader-toggles-styling" onClick={Dashboard}>  <span>Dashboard </span> </Nav.Link>
            <Nav.Link className="margin-right navheader-toggles-styling " onClick={manageClient}>  <span className='navheader-toggles-styling'>Clients </span> </Nav.Link>
            <Nav.Link className="margin-right navheader-toggles-styling" onClick={addJobs} >  <span className='navheader-toggles-styling'> Jobs </span> </Nav.Link>
            {/* <Nav.Link className="margin-right navheader-toggles-styling " onClick={manageClient}>  <span className='navheader-toggles-styling'>Clients </span> </Nav.Link> */}
            {/* <Nav.Link className="margin-right navheader-toggles-styling " onClick={InterviewTabLink}>  <span className='navheader-toggles-styling'>Interviews </span> </Nav.Link> */}
            {/* <Nav.Link className="margin-right" onClick={handleHome}> <FaHome style={{marginBottom:'5px'}}/> Home</Nav.Link> */}
            {/* <Nav.Link className="margin-right" variant="dark" onClick={handleHome}> <FaHome /> Home</Nav.Link > */}
          </Nav>
          <div className='nav-details-id'>
            <p style={{margin:0,color:'white',fontSize:12}}>{aminInfo?.organization_id}</p>
            <p style={{margin:0,color:'white',fontSize:12}}>{aminInfo?.email_id}</p>
          </div>
          <Nav className="" style={{ maxHeight: '100px',marginLeft:'20px' }} >
          
         <Nav.Link className="margin-right navheader-toggles-styling"  variant="dark" onClick={handleLogout}> <FaSignOutAlt style={{marginBottom:'4px'}} /> Logout</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
    </>
  );
};

export default NavHeader;